import React from 'react';

import { useMemoOne as useMemo } from 'use-memo-one';

import AnalyticsContext from '@atlaskit/analytics-next/AnalyticsContext';

import type { EmbeddedProductMacroType } from './EmbeddedProductMacroType';

export type EmbeddedMacroParentType = 'UIKit' | 'CustomUI';
export type EmbeddedMacroType = EmbeddedMacroParentType | EmbeddedProductMacroType;

/**
 * Contributes embedded macro attributes to `forgeUIAttributes` for every Forge UI
 * analytics event fired by descendant components.
 */
export const ForgeUIEmbeddedMacroAnalyticsContext = ({
	contentId,
	isInline,
	isMigrated,
	embeddedMacroParentType,
	embeddedMacroType,
	children,
}: {
	children: React.ReactNode;
	contentId: string | undefined;
	embeddedMacroParentType: EmbeddedMacroParentType;
	embeddedMacroType: EmbeddedMacroType;
	isInline?: boolean;
	isMigrated?: boolean;
}): React.JSX.Element => {
	const data = useMemo(
		() => ({
			forgeUIAttributes: {
				contentId,
				isEmbeddedMacro: true,
				...(isInline !== undefined ? { isInline } : {}),
				...(isMigrated ? { isMigrated } : {}),
				embeddedMacroParentType,
				embeddedMacroType,
			},
		}),
		[contentId, isInline, isMigrated, embeddedMacroParentType, embeddedMacroType],
	);

	return <AnalyticsContext data={data}>{children}</AnalyticsContext>;
};
